import { Component, OnInit, AfterViewInit  } from '@angular/core';
import { SecurityService } from '../Security/security.service';
import { LogService } from '../Abstract/log.service';
import { VisualsService } from '../Abstract/visuals.service';
import { Observable, throwError } from 'rxjs';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators  } from '@angular/forms';
import { FieldArrayType, FormlyFormBuilder } from '@ngx-formly/core';

@Component({
    selector: 'base-crud',
    template: ''
})

export class BaseCRUDComponent<T extends SecurityService> implements OnInit {

    protected visuals:any = {};
    protected genericVisuals:any = {};
    protected group:string;
    protected urlParams:any = {};
    protected bean:any = {};
    protected loading:boolean = false;
    protected submiting:boolean = false;
    protected editForm : FormGroup;
    protected validationMessages= {};
    protected getValidationMessages():void{};
     
 // protected dateRegex = /(^(((0[1-9]|[12][0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
    protected dateRegex = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
    protected intRegex = /(^[0-9]\d*$)/;
    protected alphanumeric=/^[a-zA-Z0-9]+$/;
    protected alpha = /^[a-zA-Z ]*$/;
    protected swiftCode = /^[ A-Za-z0-9/?:().,'+=-]*$/;  
    protected nonalpha = /^[0-9*!@#\$%\^\&*\)\(+=._-]+$/
    protected email =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    protected decimalRegex = /^[0-9]+(\.[0-9]{1,2})?$/; 

    //Used to show user's choice on confirmation modal
    protected requestActionMsg:any= {};
    protected confirmationMsg = "";
    protected confirmationLoader = false;
    protected confirmationFlag = "";

    constructor(protected logger: LogService, protected visualsService: VisualsService, 
                protected route: ActivatedRoute, protected fb:FormBuilder, protected router:Router){
      
    }

    ngOnInit(): void {
        this.loadVisuals();
        this.fillView();
        this.initLoadBean();
    }

    protected fillView(){}

    protected loadVisuals():void{
        this.getGenericVisuals();
        this.getVisuals();
    }

    protected getVisuals(){
        this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
        this.getValidationMessages();
    }

    protected getGenericVisuals(){
        this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];
    }

    protected loadBean(map:Map<string, any>):any{}

    protected save(bean:any){}

    protected initLoadBean(){
        this.urlParams = {};

        this.route.queryParams.subscribe(
            params => {
                this.logger.warn(params);
                this.urlParams = params;
                if(this.loadBean(this.urlParams) != null){
                this.loading = true;
            }
            error => {
               return throwError(error);
            }
        });
    }
    groupBy(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      };
      mapFields(fields: any[]) {
        return fields.map(fl => {
          fl.label = this.visuals[fl.label];
          fl.fields.map(el=>{
            this.mapFieldGroups(el)
            return el;
          })
            return fl;
        });
    }
     
    mapFieldGroups(fieldArray: any) {
        if (fieldArray.hasOwnProperty('fieldGroup')) {
            fieldArray['fieldGroup'].map(fieldGroup => {
                this.templateOptionsMapping(fieldGroup);
                if (fieldGroup.hasOwnProperty('fieldArray')) {
                    this.mapFieldGroups(fieldGroup['fieldArray']);
                }
            });
        }
    }

    templateOptionsMapping(formlyOption:any):any {
        if(formlyOption.templateOptions && formlyOption.templateOptions.options) {
            if(formlyOption.templateOptions.isnotLKP){
                formlyOption.templateOptions.options = this[formlyOption.templateOptions.options];
            }
            else{
                formlyOption.templateOptions.options = this.visualsService.getLkpFromStorageAsJSON(formlyOption.templateOptions.options, true);
            }
        }
        if(formlyOption.templateOptions){
            formlyOption.templateOptions.label = formlyOption.key ? this.visuals[formlyOption.key] : this.visuals[formlyOption.templateOptions.label];
            formlyOption.templateOptions.innerLabel = this.visuals[formlyOption.templateOptions.innerLabel];
            formlyOption.templateOptions.addButton = this.visuals[formlyOption.templateOptions.addButton];
        }
        if (formlyOption.templateOptions && formlyOption.templateOptions.change) {
            formlyOption.templateOptions.change = Function('$index', '$event', formlyOption.templateOptions.change).bind(this);
        }
        if (formlyOption.templateOptions && formlyOption.templateOptions.onClick) {
            formlyOption.templateOptions.onClick = Function('field', '$event', formlyOption.templateOptions.onClick).bind(this);
        }
    }
}